import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@stitch-fix/mode-react';
import './styles.module.scss';

/**
 * This component handles a grouped list with a grid layout of details.
 * A DetailsList can be made up of 'labeled details' (example: Materials, which
 * shows up in the UI as a label/value pair e.g Materials: Wool) or 'unlabeled
 * details' (example: a product's description, which shows up as a block of text
 * i.e. a value without a corresponding label)
 */

const DetailsList = ({
  title,
  list,
}: {
  title: string;
  list: { label: string; value: string }[];
}) => {
  let titleText = null;

  if (title) {
    titleText = (
      <Text setting="title-small" spacingBottom>
        {title}
      </Text>
    );
  }

  return (
    <>
      {!!list.length && (
        <Box mt={{ sm: 1, lg: 1.5 }}>
          {titleText}
          <Box as="dl" styleName="list">
            {list.map(({ label, value }) => (
              <Fragment key={label}>
                <Text as="dt" setting="body-small">
                  <strong>{label}</strong>
                </Text>
                <Text as="dd" setting="body-small">
                  {value}
                </Text>
              </Fragment>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

DetailsList.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node.isRequired,
    }),
  ).isRequired,
};

DetailsList.defaultProps = {
  title: null,
};

export default DetailsList;
